import dayjs from 'dayjs';

import {
  subscriptionRecurrence,
  subscriptionStatus,
} from '@rockalingua/shared/subscriptions/constants';

export default function isSubscriptionAboutToExpire(subscription) {
  return (
    subscription.status == subscriptionStatus.ACTIVE &&
    subscription.recurrence == subscriptionRecurrence.NONE &&
    dayjs().add(8, 'day').isAfter(subscription.expirationDate, 'day')
  );
}
